import IndexSummary from '../../../common/index-summary'

export default IndexSummary;
